import { InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

export const DiSocketApiUrl = new InjectionToken(`Socket API URL`, {
  providedIn: 'root',
  factory: () => environment.socket_api_url,
});
